export enum STOCK_STATUS {
    discontinued = 'discontinued',
    outOfStock = 'outOfStock',
    addToCartSTH = 'addToCartSTH',
    addToCartRedirectPDP = 'addToCartRedirectPDP',
    addToCartInStore = 'addToCartInStore',
}

export const STOCK_STATUS_MESSAGES: Record<string, string> = {
    [STOCK_STATUS.addToCartRedirectPDP]: 'This item is currently out of stock at your store',
    [STOCK_STATUS.outOfStock]: 'This item is currently out of stock',
    [STOCK_STATUS.discontinued]: 'This item is no longer available or has been discontinued',
    [STOCK_STATUS.addToCartInStore]: '',
    [STOCK_STATUS.addToCartSTH]: '',
};

export enum ADD_TO_CART_ANALYTICS_LIST {
    REORDER_ALL = 'ReorderAll',
    REORDER_ITEM = 'ReorderItem',
}

export const ADD_TO_CART_FAILURE_MESSAGE = "We couldn't add this item to your cart. Please try again in a moment.";

export const POST_ADD_TO_CART_FAILURE_COOLDOWN_MS = 3000;
